import { Box, customStyled } from '@mafc/trolly';

export const ShipmentCard = customStyled(Box)(() => ({}));
